/**
 * Pricing Slider
 */

const moneyFormat = require('./moneyFormat')

let value = 0
let sliderElement, mrrElement, priceElement

function init() {
  sliderElement = document.getElementById('js-price-slider')
  mrrElement = document.getElementById('js-slider-mrr')
  priceElement = document.getElementById('js-calculated-price')

  if (!sliderElement || !mrrElement || !priceElement) {
    return
  }

  value = sliderElement.value

  sliderElement.addEventListener('change', updatePrice)
  sliderElement.addEventListener('input', updatePrice)
}

function updatePrice(event) {
  value = parseInt(event.target.value)

  const prices = [50, 100, 250]
  const revenues = [1, 1000000, 2000000, 3000000]

  let price

  revenues.forEach( (revenueLevel, i) => {
    if(value == 3000000) {
      jQuery('.pricing__contact').addClass('active');
      jQuery('.pricing__normal').removeClass('active');
      jQuery('#js-slider-mrr').addClass('maximum');
    } else {
      jQuery('.pricing__contact').removeClass('active');
      jQuery('.pricing__normal').addClass('active');
      jQuery('#js-slider-mrr').removeClass('maximum');
    }

    if ( price ) {
      return
    }

    if ( value < revenueLevel ) {
      price = prices[i]
      return;
    }
  })

  mrrElement.innerHTML = moneyFormat.moneyFormat(value)
  priceElement.innerHTML = moneyFormat.moneyFormat(price)
}

module.exports = {
  init,
}

if(jQuery('#js-price-slider').length) {
  jQuery(window).on('load', function() {
    jQuery('#js-price-slider').val(500000);
  });
}
